





























































import { Component, Vue } from 'vue-property-decorator'
import { mapActions } from 'vuex'
import { loginFun, getUserInfoRequest } from '@/api/login'
@Component({
  data() {
    return {
      form: this.$form.createForm(this),
    }
  },
})
export default class Login extends Vue {
  private form: any;
  private loading: boolean = false; //按钮加载状态
  handleSubmit(e: any) {
    e.preventDefault()
    const {
      form: { validateFields },
    } = this
    validateFields((err: any, values: any) => {
      if (!err) {
        const params = {
          userName: values.userName,
          password: values.password,
        }
        this.loading = true
        this.getLoginFun(params)
      }
    })
  }
  //登录
  async getLoginFun(params: any) {
    try {
      loginFun(params).then((res: any) => {
        if (res.status == 0 && res.data) {
          Vue.ls.set('ACCESS_TOKEN', res.data.userToken, 2 * 60 * 60 * 1000)
          getUserInfoRequest().then((respon: any) => {
            if (respon.status == 0 && respon.data) {
              localStorage.setItem('client', JSON.stringify(respon.data))
              this.loading = false
              this.$message.success('登录成功')
              this.$router.push({
                path: '/home',
              })
            } else {
              Vue.ls.remove('ACCESS_TOKEN')
              this.loading = false
              this.$message.error(respon.message)
            }
          })
        } else {
          this.loading = false
          this.$message.error(res.message || '登录失败')
        }
      })
    } catch (err: any) {
      this.loading = false
      this.$message.warning('请求异常')
    }
  }
}
